import { render, staticRenderFns } from "./LayoutHelpCenter.vue?vue&type=template&id=22fae768&"
import script from "./LayoutHelpCenter.vue?vue&type=script&lang=ts&"
export * from "./LayoutHelpCenter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports